import {Internationalization} from "@spectrumselect/mi-ui-react";

export const local = new Internationalization({
  localeJson: require("./locales/en_US.json"),
  defaultLocale: "en-US",
  pseudoLocalizationEnabled: false
});
